import React from 'react'
import { styledTableStatus, StatusLabel } from "../../config/styledTableStatus";
import { Translate } from './Translate';


const StatusIcon = ({status, margin}) => status ? <StatusLabel data-cy={`label-${status}`} margin={margin} status={{...styledTableStatus[status]}}>
        {styledTableStatus[status] ? <Translate id={`statusCases.${styledTableStatus[status].text}`}/> : <Translate id={`statusCases.${status}`}/>}
    </StatusLabel> : ''
export default StatusIcon